<form>
  <div class="lv-modal-dialog">
    <div mat-dialog-title class="lv-dialog-header">
      <div class="lv-dialog-header-title" [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN.TITEL' | translate">
      </div>
      <div class="lv-dialog-icon-close">
        <mat-icon [svgIcon]="'Times'" (click)="abbrechenButtonClicked()"></mat-icon>
      </div>
    </div>
    <div mat-dialog-content class="lv-dialog-content">
      <div class="lv-dialog-portfolio-speichern">
        <div [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN.MELDUNG' | translate">
        </div>
        <div class="lv-dialog-portfolio-speichern-portfolio-name">
          <lv-label-tooltip [label]="'Titel'" [isPflichtfeld]="true"></lv-label-tooltip>
          <lv-material-form-input lvPortfolioNameValidator
                                  #portfolio="ngModel"
                                  [(ngModel)]="portfolioName"
                                  [name]="'portfolioName'"
                                  [isTouched]="portfolio.touched"
                                  [isDirty]="portfolio.dirty"
                                  [outerErrors]="portfolio.errors"
                                  [errorPath]="'FONDS'"
                                  [required]="true"></lv-material-form-input>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="lv-dialog-footer" align="end">
      <button mat-raised-button color="accent" (click)="abbrechenButtonClicked()">
        <span [innerHTML]="'MODAL_DIALOG.WECHSEL_ANLAGESTRATEGIE.BUTTON_ABBRECHEN' | translate"></span>
      </button>
      <button mat-raised-button color="primary" (click)="speichernButtonClicked()">
        <span [innerHTML]="'MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN.BUTTON_SPEICHERN' | translate"></span>
      </button>
    </div>
    <div class="lv-pflichtfeld-hinweis_modal_dialog" [innerHTML]="'INFOTEXT.PFLICHTFELD_ANGABE' | translate"></div>
  </div>
</form>
